// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"_3xDmT6upI8gh0o8F_tdd2","listItem":"G3v-O4buStJn746GCH1gK","pointer":"_3Rb5zrNNU1fRiR5_Ilw1d-","cardContainer":"_3q4KQdbL-HDI54ek6gk1ut"};